@if (!isFootnotesGrid) {
<div class="kendo-grid-wrapper">
    <!-- formInstanceElementId:{{formInstanceElementId}} (handy for debugging) -->
    @if (!HideFormFieldBody) {
    @if (FormFieldId) {
    <kendo-grid #grid="kendoGridRemoteBindingRef"
                #kendoGridComponent
                kendoGridRemoteBinding
                (notifyLoaded)="handleLoaded($event)"
                [gridConfig]="gridFormFieldComponent.GridConfig"
                [fieldDefinitionService]="FieldDefinitionService"
                [getCellDisplayValue]="GridFormFieldComponent"
                [formInstanceElementId]="FormInstanceElementId"
                [kendoGridService]="KendoGridService"
                [rowReorderable]="CanReorderRows"
                [pageSize]="VirtualScrollingPageSize"
                [skip]="VirtualScrollingSkip"
                [sort]="dataUsedWithKendoGrid.gridState.sort"
                scrollable="{{ScrollMode}}"
                [rowHeight]="RowHeightForVirtualScrolling"
                [height]="GetGridHeight()"
                [selectable]="true"
                [sortable]="SortSettings"
                [columnMenu]="ColumnMenuSettings"
                [filterable]="'menu'"
                [navigable]="true"
                [resizable]="true"
                (cellClick)="handleEditCellClick($event)"
                (edit)="handleEdit($event)"
                (cancel)="handleCancel($event)"
                (cellClose)="handleCellClose($event)"
                (save)="handleAddOrUpdate($event)"
                (remove)="handleRemove($event)"
                (add)="addRowToUI($event)"
                (rowReorder)="handleRowReorder($event)"
                (detailExpand)="handleDetailExpand($event)"
                (detailCollapse)="handleDetailCollapse($event)"
                [(filter)]="Helper.Filter"
                (filterChange)="filterChange()">
        <ng-template kendoGridToolbarTemplate>
            @if (ShowAddRowButton) {
            <button [disabled]="ModifyRowDisabled || NewRowDisabled" class="grid-toolbar-button" kendoGridAddCommand (click)="addValidationAndFlagForNewKendoRow()">
                New Row
            </button>
            }
            @if(ShowEditingInfo){
            Your edits will be saved permanently when you save the form or change its workflow
            @if(ShowDoneEditingButton){
            <button mat-stroked-button class="grid-toolbar-button" (click)="handleDoneEditing()">
                Done Editing
            </button>
            }
            @if(ShowCancelChangesButton){
            <button mat-stroked-button class="grid-toolbar-button" (click)="handleCancelAllEdits()">
                Cancel Changes
            </button>
            }
            }
            @if (GridIsFilterable) {
            <div>
                @if (ShowGridFilter) {
                @for (preset of FilterPresets; track preset) {
                <button mat-flat-button
                        color="primary"
                        class="preset-button"
                        (click)="selectPresetFilter(preset)"
                        title="{{preset.filterName}}">
                    <mat-icon>filter_alt</mat-icon>
                    {{preset.filterName}}
                </button>
                }
                }
            </div>
            }
            <kendo-grid-spacer></kendo-grid-spacer>
            @if (ShowGeocodeGrid()) {
            <button mat-button (click)="geoCodeGrid();">
                <mat-icon aria-hidden="false" aria-label="Geocode address data in grid" class="geocode-data-mat-icon" title="Geocode address data in grid">language</mat-icon>
            </button>
            }
            @if (ShowPasteButton) {
            <button mat-button (click)="showPasteAreaKendo();">
                <mat-icon aria-hidden="false" aria-label="Paste from Excel into grid" class="paste-data-mat-icon" title="Paste from Excel into grid">content_paste</mat-icon>
            </button>
            }
            @if (ShowDownloadToExcelButton) {
            <button mat-button (click)="exportGridDataClicked()">
                <mat-icon aria-hidden="false" aria-label="Download grid data" class="export-grid-data-mat-icon" title="Download grid data" svgIcon="microsoft-excel"></mat-icon>
            </button>
            }
            @if (ShowUploadFromExcelButton) {
            <input type="file"
                   accept=".xlsx,.xls"
                   #selectExcelFile
                   class="hidden-file-input"
                   (change)="onExcelFileChanged($event)" />
            <button class="grid-button" mat-button (click)="importGridDataClicked()">
                <mat-icon aria-hidden="false" aria-label="Upload grid data from Excel file" title="Upload grid data from Excel">upload_file</mat-icon>
            </button>
            }
            @if (ShowClearGridButton) {
            <button mat-button
                    [disabled]="HasNoRows"
                    (click)="clearGridDataClicked()">
                <mat-icon aria-hidden="false" aria-label="Clear grid data" class="export-grid-data-mat-icon" title="Clear grid data">clear_all</mat-icon>
            </button>
            }
            @if (Helper.IsBeingFiltered) {
            <button class="clear-all-filters-btn" mat-stroked-button (click)='Helper.handleClearFilters()'>Clear All Filters</button>
            {{Helper.ShowingXofN}}
            }
        </ng-template>
        @if (ShowRowNumbers) {
        <kendo-grid-column [width]="20" [class]="'!k-text-center'" [columnMenu]="false">
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
                @if (rowIndex > -1) {
                @if(isPending(dataItem)){
                <span class="pending-row">
                    <span title="Row {{rowIndex + 1}} has been edited and will be saved when the Form is saved">
                        {{ rowIndex + 1 }}*
                    </span>
                </span>
                }
                @else{
                <span title="{{rowIndex + 1}}">
                    {{ rowIndex + 1 }}
                </span>
                }
                }
            </ng-template>
        </kendo-grid-column>
        }
        @if (CanReorderRows) {
        <kendo-grid-rowreorder-column [width]="16" [columnMenu]="false"></kendo-grid-rowreorder-column>
        }
        @if (ShowLockRowsColumn) {
        <kendo-grid-column [width]="25" [class]="'!k-text-center'" [columnMenu]="false">
            @if(UserCanLockGridRows){
            <ng-template kendoGridCellTemplate let-dataItem>
                <mat-icon class="row-action-icon" (click)="toggleLock($event, dataItem)" title="{{getLockTitleFor(dataItem)}}">{{ getLockIconFor(dataItem) }}</mat-icon>
            </ng-template>
            }
            @else{
            <ng-template kendoGridCellTemplate let-dataItem>
                <mat-icon class="row-action-icon" style="color:{{getLockColor(dataItem)}}" title="{{getLockTitleFor(dataItem)}}">{{ getLockIconFor(dataItem) }}</mat-icon>
            </ng-template>
            }
        </kendo-grid-column>
        }
        @for (columnDef of GridColumnDefs; track columnDef; let iColIndex = $index) {
        @if (ShowColumnInRow(columnDef)) {
        <kendo-grid-column field="{{columnDef.name}}"
                           title="{{columnDef.displayName != null ? columnDef.displayName : columnDef.name}}"
                           [editable]="!IsReadOnlyGrid"
                           [filterable]="ColumnIsFilterable(columnDef)"
                           [sortable]="IsSortable(columnDef)"
                           [width]="GetColumnWidth(columnDef)">

            <!-- This customizes the filter menu on the Column Menu so that we don't get a multi-level filter, but just a simple, single value on -->
            <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
                @switch(FilterType(columnDef)){
                @case('text'){
                <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [extra]="false" [filterService]="filterService"></kendo-grid-string-filter-menu>
                }
                @case('numeric'){
                <kendo-grid-numeric-filter-menu [column]="column" [filter]="filter" [extra]="false" [filterService]="filterService"></kendo-grid-numeric-filter-menu>
                }
                @case('date'){
                <kendo-grid-date-filter-menu [column]="column" [filter]="filter" [extra]="false" [filterService]="filterService"></kendo-grid-date-filter-menu>
                }
                @case('boolean'){
                <kendo-grid-boolean-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"></kendo-grid-boolean-filter-menu>
                }
                }
            </ng-template>

            <!-- Added to enable use of title attribute for hover text -->
            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                <span title="{{column.title}}" class="column-header">
                    {{column.title}}
                </span>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div class="kendo-cell" title="{{getCellDisplayValueForKendo(dataItem, columnDef, iColIndex)}}">
                    <!-- this div will fill the cell unless the show in dialog icon displays which will display at the end of the cell -->
                    <div style="flex-grow: 1; overflow:hidden;">
                        <!-- Some modifications here to allow cells to be displayed in different ways - span (the default) link, button -->
                        @if (ShowColumnAs(columnDef) == 'SPAN') {
                        <span [innerHTML]="getCellDisplayValueForKendo(dataItem, columnDef, iColIndex)"></span>
                        }
                        @if (ShowColumnAs(columnDef) == 'LINK') {
                        <a class="html-display"
                           href="{{getCellDisplayValueForKendo(dataItem, columnDef, iColIndex)}}"
                           target="_blank">{{getCellDisplayValueForKendo(dataItem, columnDef, iColIndex)}}</a>
                        }
                        <!-- A field that needs to display itself as a button in a Grid cannot handle its own (click) event so it has to get handled here -->
                        @if (ShowColumnAs(columnDef) == 'BUTTON') {
                        <button kendoButton
                                class="grid-field-button"
                                [disabled]="!allParamsSuppliedForConcatenator(dataItem, columnDef, iColIndex)"
                                (click)="openUrl(getCellDisplayValueForKendo(dataItem, columnDef, iColIndex))">
                            {{ButtonLabel(columnDef)}}
                        </button>
                        }
                    </div>
                    @if(ShowCellContentsOpenIcon(dataItem, columnDef)){
                    <div>
                        <mat-icon style="font-size: 14pt; color: dimgrey;" title="View Cell Contents in Dialog"
                                  (click)="this.viewInDialog(dataItem, columnDef, iColIndex, rowIndex)">open_in_new</mat-icon>
                    </div>
                    }
                </div>
                @if (ShowNumericTotalsFooter) {
                <ng-template kendoGridFooterTemplate>
                    {{ getNumericFooterTotalValueFor(iColIndex) | number}}
                </ng-template>
                }
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem let-rowIndex="rowIndex">
                <app-form-field-wrapper [formField]="columnDef"
                                        [formInstance]="FormInstance"
                                        [mode]="'instance'"
                                        [readOnly]="false"
                                        [fieldIsInGrid]="true"
                                        [gridRowId]="DataUsedWithKendoGrid.selectedGridRow?.DatabaseId"
                                        [gridColumnDefs]="GridColumnDefs"
                                        (mimickedNgModelChange)="handleMimickedNgModelChange($event)"
                                        (onInit)="gridColumnInit($event, columnDef)"
                                        (formStatusChanged)="handleValidityChange($event)"
                                        (wrapperFormControlCreated)="handleWrapperFormControlCreated($event)"
                                        (touched)="handleTouched($event)"
                                        (enterKeyPressed)="handleEnterKeyPressed()"
                                        (openGridCellEditorClicked)="handleOpenGridCellEditorClicked($event)">
                </app-form-field-wrapper>
                @if (ShowNumericTotalsFooter) {
                <ng-template kendoGridFooterTemplate>
                    {{ getNumericFooterTotalValueFor(iColIndex) | number }}
                </ng-template>
                }
            </ng-template>
        </kendo-grid-column>
        }
        }
        <kendo-grid-command-column [width]="CommandColumnWidth" [columnMenu]="false">
            <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem let-RowIndex="rowIndex">
                @if (rowUsesButton('delete', dataItem) && !HideRowDelete && !RowIsLocked(dataItem)) {
                <button [disabled]="ModifyRowDisabled"
                        aria-label="Delete Row"
                        class="grid-row-btn"
                        kendoGridRemoveCommand
                        kendoGridFocusable>
                    Delete
                </button>
                }

                @if (!IsReadOnlyGrid && rowUsesButton('save', dataItem)) {
                <button aria-label="Done Editing Row"
                        class="grid-row-btn"
                        kendoGridSaveCommand
                        kendoGridFocusable
                        [disabled]="IsSaveGridRowButtonDisabled || AtLeastOneFieldIsInvalid">
                    Done
                </button>
                }
                @if (!IsReadOnlyGrid && rowUsesButton('cancel', dataItem)) {
                <button aria-label="Cancel Edits to Row"
                        class="grid-row-btn"
                        kendoGridCancelCommand
                        kendoGridFocusable
                        (click)="removeNewKendoRowFlag()">
                    Cancel
                </button>
                }
                @if (rowUsesButton('disable', dataItem)) {
                <button aria-label="Delete Attachment"
                        [disabled]="ModifyRowDisabled"
                        kendoButton
                        class="command-btn"
                        (click)="emitGridEvent(dataItem, 'delete')">
                    <mat-icon class="row-action-icon" title="Delete Attachment">delete</mat-icon>
                </button>
                }
                @if (rowUsesButton('restore', dataItem) && userCanRestore()) {
                <button aria-label="Restore Attachment"
                        [disabled]="ModifyRowDisabled"
                        kendoButton
                        class="command-btn"
                        (click)="emitGridEvent(dataItem, 'restore')">
                    <mat-icon class="row-action-icon" title="Restore Attachment">restore_from_trash</mat-icon>
                </button>
                }
                @if (rowUsesButton('download', dataItem)) {
                <button aria-label="Download File"
                        kendoButton
                        class="command-btn"
                        (click)="emitGridEvent(dataItem, 'download')">
                    <mat-icon title="Download File" class="row-action">download</mat-icon>
                </button>
                }
                @if (rowUsesButton('upload', dataItem)) {
                <button aria-label="Upload new version of file"
                        [disabled]="ModifyRowDisabled"
                        kendoButton
                        class="command-btn"
                        (click)="emitGridEvent(dataItem, 'upload')">
                    <mat-icon title="Upload new version of file" class="row-action">upload</mat-icon>
                </button>
                }
            </ng-template>
        </kendo-grid-command-column>
        <!-- Row Expansion to show detail pane -->
        @if (GridHasDetail(); as dataItem) {
        <ng-template kendoGridDetailTemplate let-dataItem>
            <div #rowDetailPanel>
                @for (columnDef of GridColumnDefs; track columnDef; let iColIndex = $index) {
                    @if (ShowColumnInDetail(columnDef)) {
                        @if (RowEditInProgress) {
                        <app-form-field-wrapper [formField]="columnDef"
                                                [mode]="'instance'"
                                                [readOnly]="false"
                                                (onInit)="gridColumnInit($event, columnDef)"
                                                (ngModelChange)="gridColumnValueChanged(columnDef,DataUsedWithKendoGrid.selectedGridRow?.FormInstanceElementWrappers[iColIndex].formInstanceElement)"
                                                (formStatusChanged)="handleValidityChange($event)">
                        </app-form-field-wrapper>
                        }
                        @if (!RowEditInProgress) {
                        <div>
                            <strong>{{columnDef.displayName}}</strong>: {{ getCellDisplayValueForKendo(dataItem, columnDef, iColIndex) }}
                        </div>
                        }
                    }
                }
            </div>
        </ng-template>
        }
    </kendo-grid>
    }
    }
    <span>{{GetGridRowinfo}}</span>
    @if (HideFormFieldBody) {
    <div class="export-import-buttons-only-div">
        <!-- Note:  this <div/> only shows a grid's export and import buttons. -->
        <button mat-button (click)="exportGridDataClicked()" aria-label="Download grid data" title="Download grid data">
            <img src="assets/images/v3_download.png" alt="">
        </button>
        <ng-container>
            <input type="file"
                   accept=".xlsx,.xls"
                   #selectExcelFile
                   class="hidden-file-input"
                   (change)="onExcelFileChanged($event)" />
            <button class="grid-button"
                    aria-label="Upload from Excel"
                    mat-button
                    (click)="this.importGridDataClicked()" title="Upload grid data from Excel">
                <img src="assets/images/v3_upload.png" alt="">
            </button>
        </ng-container>
    </div>
    }
    <div style="height:10px;">
        @if (Saving) {
        <span>Saving...</span>
        }
    </div>
</div>
}
